import React from "react";
import PropTypes from "prop-types";

import styles from "./Button.module.css";

const Button = props => {
  return (
    <a className={styles.button} onClick={props.onClick} {...props}>
      {props.children}
    </a>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/contact/Formular/Button.js